module.exports = __webpack_public_path__ + "static/media/tidy-white.00f63b25.svg";